import React from 'react';
import { Link } from 'react-router-dom';

import config from './Config'

import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-page">

      <header className="terms-header">
        <div className="terms-nav">
          <Link to="/" className="terms-nav-logo">
            {config.brandname}
          </Link>
          <div className="terms-nav-links">
            <Link to="/" className="terms-nav-link">Home</Link>
            <Link to="/privacy" className="terms-nav-link">Privacy Policy</Link>
            <Link to="/contact" className="terms-nav-link">Contact</Link>
          </div>
        </div>
      </header>


      <main className="terms-content">
        <div className="terms-container">
          <div className="terms-header-section">
            <h1 className="terms-title">Terms of Service</h1>
            <p className="terms-subtitle">Last Updated: {new Date().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}</p>
            <div className="terms-version">Version 2.0</div>
          </div>

          <div className="terms-intro">
            <p>
              Welcome to {config.brandname}. By accessing or using our services, you agree to be bound by these Terms of Service.
              Please read them carefully before using our application.
            </p>
          </div>


          <div className="terms-toc">
            <h3>Table of Contents</h3>
            <ul className="toc-list">
              <li><a href="#acceptance">1. Acceptance of Terms</a></li>
              <li><a href="#description">2. Description of Service</a></li>
              <li><a href="#registration">3. User Registration</a></li>
              <li><a href="#conduct">4. Acceptable Use</a></li>
              <li><a href="#privacy">5. Privacy Policy</a></li>
              <li><a href="#intellectual">6. Intellectual Property</a></li>
              <li><a href="#termination">7. Termination</a></li>
              <li><a href="#disclaimer">8. Disclaimer of Warranties</a></li>
              <li><a href="#limitation">9. Limitation of Liability</a></li>
              <li><a href="#indemnification">10. Indemnification</a></li>
              <li><a href="#modifications">11. Modifications to Terms</a></li>
              <li><a href="#governing">12. Governing Law</a></li>
              <li><a href="#contact">13. Contact Information</a></li>
            </ul>
          </div>


          <div className="terms-sections">
            <section id="acceptance" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">1.</span> Acceptance of Terms
              </h2>
              <p>
                By downloading, installing, or using the {config.brandname} mobile application and related services,
                you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
                If you do not agree to these terms, please do not use our services.
              </p>
              <p>
                These terms constitute a legally binding agreement between you and {config.brandname} Inc. regarding your
                use of the application.
              </p>
            </section>

            <section id="description" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">2.</span> Description of Service
              </h2>
              <p>
                {config.brandname} provides a comprehensive home management platform that allows users to:
              </p>
              <ul className="terms-list">
                <li>Monitor and control smart home devices</li>
                <li>Track home maintenance and repairs</li>
                <li>Manage home-related finances and budgets</li>
                <li>Receive notifications about home status</li>
                <li>Automate home routines and schedules</li>
                <li>Monitor energy consumption</li>
              </ul>
              <p>
                We reserve the right to modify, suspend, or discontinue any aspect of the service at any time,
                including the availability of any feature, database, or content.
              </p>
            </section>

            <section id="registration" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">3.</span> User Registration
              </h2>
              <p>
                To access certain features of {config.brandname}, you must register for an account. You agree to:
              </p>
              <ul className="terms-list">
                <li>Provide accurate, current, and complete information during registration</li>
                <li>Maintain and promptly update your account information</li>
                <li>Maintain the security of your password and accept all risks of unauthorized access</li>
                <li>Notify us immediately of any unauthorized use of your account</li>
                <li>Be responsible for all activities that occur under your account</li>
              </ul>
              <p>
                You must be at least 18 years old to create an account and use {config.brandname} services.
              </p>
            </section>

            <section id="conduct" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">4.</span> Acceptable Use
              </h2>
              <p>
                You agree not to use the {config.brandname} service to:
              </p>
              <ul className="terms-list terms-list-warning">
                <li>Violate any applicable laws, regulations, or third-party rights</li>
                <li>Upload or transmit viruses, malware, or any other malicious code</li>
                <li>Attempt to gain unauthorized access to our systems or other users' accounts</li>
                <li>Use the service for any fraudulent or illegal purposes</li>
                <li>Interfere with or disrupt the integrity or performance of the service</li>
                <li>Reverse engineer, decompile, or disassemble any portion of the application</li>
                <li>Collect or harvest any information from the service without authorization</li>
              </ul>
              <p>
                We reserve the right to investigate and prosecute violations of these terms to the fullest
                extent of the law.
              </p>
            </section>

            <section id="privacy" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">5.</span> Privacy Policy
              </h2>
              <p>
                Your privacy is important to us. Our <Link to="/privacy" className="inline-link">Privacy Policy</Link> explains
                how we collect, use, and protect your personal information. By using {config.brandname}, you consent to
                the collection and use of your information as described in our Privacy Policy.
              </p>
              <p>
                We implement security measures to protect your data, but no system can be completely secure.
                You are responsible for maintaining the confidentiality of your login credentials.
              </p>
            </section>

            <section id="intellectual" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">6.</span> Intellectual Property
              </h2>
              <p>
                All content, features, and functionality of {config.brandname}, including but not limited to text, graphics,
                logos, icons, images, audio clips, digital downloads, and software, are the exclusive property
                of {config.brandname} Inc. and are protected by international copyright, trademark, and other intellectual
                property laws.
              </p>
              <p>
                The {config.brandname} name and logo are trademarks of {config.brandname} Inc. You may not use these marks without our
                prior written permission.
              </p>
              <p>
                You retain ownership of any content you submit to the service, but you grant us a worldwide,
                non-exclusive, royalty-free license to use, reproduce, modify, and display such content for
                the purpose of providing and improving our services.
              </p>
            </section>

            <section id="termination" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">7.</span> Termination
              </h2>
              <p>
                We may terminate or suspend your account and access to the service immediately, without prior
                notice or liability, for any reason, including but not limited to:
              </p>
              <ul className="terms-list">
                <li>Breach of these Terms of Service</li>
                <li>Requests by law enforcement or other government agencies</li>
                <li>Discontinuance or material modification of the service</li>
                <li>Unexpected technical or security issues</li>
                <li>Extended periods of inactivity</li>
              </ul>
              <p>
                Upon termination, your right to use the service will immediately cease. All provisions of
                these terms which by their nature should survive termination shall survive, including ownership
                provisions, warranty disclaimers, indemnity, and limitations of liability.
              </p>
            </section>

            <section id="disclaimer" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">8.</span> Disclaimer of Warranties
              </h2>
              <div className="terms-warning-box">
                <p>
                  THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. {config.brandname} INC. EXPRESSLY DISCLAIMS
                  ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED
                  WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
                </p>
              </div>
              <p>
                We do not warrant that:
              </p>
              <ul className="terms-list">
                <li>The service will meet your specific requirements</li>
                <li>The service will be uninterrupted, timely, secure, or error-free</li>
                <li>The results that may be obtained from the use of the service will be accurate or reliable</li>
                <li>The quality of any products, services, information, or other material obtained through the service will meet your expectations</li>
              </ul>
            </section>

            <section id="limitation" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">9.</span> Limitation of Liability
              </h2>
              <div className="terms-warning-box">
                <p>
                  IN NO EVENT SHALL {config.brandname} INC., ITS DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT,
                  INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION LOSS OF
                  PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM:
                </p>
                <ul>
                  <li>YOUR USE OR INABILITY TO USE THE SERVICE</li>
                  <li>ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SERVERS AND/OR ANY PERSONAL INFORMATION STORED THEREIN</li>
                  <li>ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SERVICE</li>
                  <li>ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE THAT MAY BE TRANSMITTED THROUGH THE SERVICE</li>
                  <li>ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS OR DAMAGE INCURRED AS A RESULT OF THE USE OF ANY CONTENT</li>
                </ul>
              </div>
            </section>

            <section id="indemnification" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">10.</span> Indemnification
              </h2>
              <p>
                You agree to defend, indemnify, and hold harmless {config.brandname} Inc. and its affiliates, officers,
                directors, employees, and agents from and against any and all claims, damages, obligations,
                losses, liabilities, costs, or debt, and expenses (including but not limited to attorney's fees)
                arising from:
              </p>
              <ul className="terms-list">
                <li>Your use of and access to the service</li>
                <li>Your violation of any term of these Terms of Service</li>
                <li>Your violation of any third-party right, including without limitation any copyright, property, or privacy right</li>
                <li>Any claim that your content caused damage to a third party</li>
              </ul>
            </section>

            <section id="modifications" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">11.</span> Modifications to Terms
              </h2>
              <p>
                We reserve the right, at our sole discretion, to modify or replace these Terms of Service at
                any time. If a revision is material, we will provide at least 30 days' notice prior to any new
                terms taking effect. What constitutes a material change will be determined at our sole discretion.
              </p>
              <p>
                By continuing to access or use our service after those revisions become effective, you agree to
                be bound by the revised terms. If you do not agree to the new terms, please stop using the service.
              </p>
            </section>

            <section id="governing" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">12.</span> Governing Law
              </h2>
              <p>
                These Terms of Service shall be governed and construed in accordance with the laws of the State
                of Delaware, United States, without regard to its conflict of law provisions.
              </p>
              <p>
                Any dispute arising from or relating to these terms shall be subject to the exclusive jurisdiction
                of the state and federal courts located in Delaware.
              </p>
            </section>

            <section id="contact" className="terms-section">
              <h2 className="terms-section-title">
                <span className="section-number">13.</span> Contact Information
              </h2>
              <p>
                If you have any questions about these Terms of Service, please contact us:
              </p>
              <div className="contact-info">
                <div className="contact-item">
                  <strong>Email:</strong> legal@{config.brandname}.com
                </div>
                <div className="contact-item">
                  <strong>Address:</strong> 123 Innovation Drive, Wilmington, DE 19801, USA
                </div>
                <div className="contact-item">
                  <strong>Phone:</strong> +1 (555) 123-4567
                </div>
              </div>
            </section>

            <div className="terms-agreement">
              <p>
                By using {config.brandname}, you acknowledge that you have read, understood, and agree to be bound by these
                Terms of Service.
              </p>
            </div>
          </div>
        </div>
      </main>


      <footer className="terms-footer">
        <div className="terms-footer-content">
          <div className="terms-footer-brand">
            <span className="terms-footer-logo">{config.brandname}</span>
            <p className="terms-footer-tagline">Smart Living, Simplified</p>
          </div>

          <div className="terms-footer-links">
            <Link to="/" className="terms-footer-link">Home</Link>
            <Link to="/privacy" className="terms-footer-link">Privacy Policy</Link>
            <Link to="/contact" className="terms-footer-link">Contact Us</Link>
          </div>

          <div className="terms-footer-copyright">
            © {new Date().getFullYear()} {config.brandname} Inc. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Terms;